const state = { user: null, tokens: { accessToken: null }, _logout: null };
const compat = {
  get user() { return state.user; },
  set user(v) { state.user = v; },
  get tokens() { return state.tokens; },
  init() {},
  accessToken() { return state.tokens.accessToken; },
  async logout() { if (state._logout) return state._logout(); state.user = null; state.tokens.accessToken = null; },
  _set({ user, token, logout }) { state.user = user || null; state.tokens.accessToken = token || null; state._logout = logout || null; },
};
export default compat;
